/* eslint-disable arrow-parens */
/* eslint-disable implicit-arrow-linebreak */

/**
 * The global state selectors
 */

import { createSelector } from 'reselect'
import { initialState } from './reducer'

const selectDashboardMain = state => state.dashboardMain || initialState

const makeSelectDashboardMain = () =>
  createSelector(
    selectDashboardMain,
    state => state
  )

export {
  selectDashboardMain,
  makeSelectDashboardMain
}
